import React from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, xcss } from '@atlaskit/primitives';

import { SearchLink } from '../../../../../common/ui/search-link';
import { useDropdown } from '../../../../../controllers/store';
import { useQuickSearchResults, useResultCount } from '../../../../../controllers/store/dropdown';

const iconStyles = xcss({
	width: '24px',
	height: '24px',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
});

export const QuickSearchResults = (): React.JSX.Element => {
	const [resultCount] = useResultCount();
	const [, { setShowDropdown }] = useDropdown();

	const onClick = () => {
		setShowDropdown(false);
	};

	const [quickSearchResults] = useQuickSearchResults();

	return (
		<>
			{quickSearchResults.slice(0, resultCount.quickSearch).map((result, index) => (
				<SearchLink
					title={result.title}
					description={result.description}
					subheading={result.subheading}
					icon={<Box xcss={iconStyles}>{result.icon}</Box>}
					onClick={onClick}
					highlightedTitle={result.highlightedTitle}
					key={`${index}-${result.title}`}
					navigationUrl={result.navigationUrl}
				/>
			))}
		</>
	);
};
